module.exports = __webpack_public_path__ + "static/glassdesign-c8a88a4fd3a59d0cbb1bcaf1b3a6e6eb.jpg";